import { ApiResponse } from '../../../../../types/api-response.types';
import { FilterItem } from '../../../../../types/filters.types';

export enum StatusOutcome {
  Success = 'Success',
  Failure = 'Failure',
  NA = 'N/A',
}

export interface Status {
  id: string;
  tenantId: string;
  candidateStep: string;
  stageDescription: string;
  statusCode: string;
  statusOutcome: StatusOutcome;
  purpose: string;
  actionBy: string;
  actionRequired: string;
  isDeleted?: boolean;
  deletedAt?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface StatusGetResponse extends ApiResponse<Status> {
  data: Status;
}

export interface StatusGetFiltersResponse {
  data: FilterItem[];
}

export type StatusList = Status[];

export interface StatusCreate {
  candidateStep: string;
  stageDescription: string;
  statusCode: string;
  statusOutcome: StatusOutcome;
  purpose: string;
  actionBy: string;
  actionRequired: string;
}

export interface StatusUpdate {
  candidateStep?: string;
  stageDescription?: string;
  statusCode?: string;
  statusOutcome?: StatusOutcome;
  purpose?: string;
  actionBy?: string;
  actionRequired?: string;
}
